function addToCartF(){
  // Note: 'this.event' is deprecated; it is highly recommended to pass 'e' into addToCartF(e) 
  // and use 'e.target', but keeping your raw target logic intact for now:
  let target = this.event.target;
  let parent = target.closest('.result-details-btn');

  if(parent){
    parent.classList.add('disabledF');
  }

  if (target.querySelector('.loading__spinner')) {
    target.querySelector('.loading__spinner').classList.remove('hidden');
  }

  let variant_id = target.getAttribute("data-itemid");
  let product_url = target.getAttribute("data-producturl");
  // 1. Grab the cart element from the DOM to find out what sections it needs
  const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const formData = new FormData();

  formData.append('id', variant_id);
  formData.append('quantity', '1');

  const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', product_url);
    cart.setActiveElement(document.activeElement);
  }

  config.body = formData;


  fetch(`/cart/add.js`, config)
  .then((response) => response.json())
  .then((response) => {
    
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-form',
      productVariantId: variant_id,
      cartData: response,
    });
    cart.renderContents(response);
    console.log(cart);
    
  })
  .catch((error) => {
    console.error("Error:", error);
  })
  .finally(() => {
    if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    if (target.querySelector('.loading__spinner')) {
      target.querySelector('.loading__spinner').classList.add('hidden');
    }
    if(parent){
      parent.classList.remove('disabledF');
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const priceMin = document.getElementById("priceMin");
  const priceMax = document.getElementById("priceMax");
  const inputPriceMin = document.getElementById("inputPriceMin");
  const inputPriceMax = document.getElementById("inputPriceMax");
  const filterBarRange = document.getElementById("filterBarRange");
  let categoriesBuilt = false; // at top of your script

  // STOCK toggle
  let stock = false;
  document.querySelector(".checkbox-div").addEventListener("click", () => {
    document
      .querySelector(".checkbox-btn-circle")
      ?.classList.toggle("checkox-checked");
    document
      .querySelector(".checkbox-filter")
      ?.classList.toggle("checkbox-filter-checked");
    stock = !stock;
    console.log("Stock:", stock);
    datafetch(); // ✅ Re-fetch with updated stock state
  });

  const Category_box_text = [];
  document.querySelectorAll(".category-drop-down label").forEach((label) => {
    const checkbox = label.querySelector("input");
    const span = label.querySelector("span");
    if (checkbox && span) {
      checkbox.addEventListener("change", () => {
        const text = span.innerText;
        if (checkbox.checked) {
          if (!Category_box_text.includes(text)) Category_box_text.push(text);
        } else {
          const index = Category_box_text.indexOf(text);
          if (index > -1) Category_box_text.splice(index, 1);
        }
        console.log(Category_box_text);
        datafetch();
      });
    }
  });

  // Brand filter

  let brandText = [];

  document.querySelectorAll(".brand-drop-down label").forEach((label) => {
    const brandCheckbox = label.querySelector("input");
    const brandSpan = label.querySelector("span");

    if (brandCheckbox && brandSpan) {
      brandCheckbox.addEventListener("change", () => {
        const text = brandSpan.innerText.trim();

        if (brandCheckbox.checked) {
          if (!brandText.includes(text)) brandText.push(text);
        } else {
          const index = brandText.indexOf(text);
          if (index > -1) brandText.splice(index, 1);
        }

        console.log("Brand Text:", brandText);
        datafetch(); // Call after brand selection changes
      });
    }
  });

  const moveAndFetch = () => {
    const search_filter = document.querySelector(".filter-component_main");

    const main_search_container = document.querySelector(
      ".search-results-container"
    );

    main_search_container.classList.add("new-search-container");
    if (!search_filter || !main_search_container) return;

    if (!main_search_container.contains(search_filter)) {
      main_search_container.prepend(search_filter);
      console.log("Filter moved.");
    }

    datafetch();
  };
  const buildCategoryCheckboxes = (fetchData) => {
    const allCategories = new Set();
    fetchData.forEach((item) => {
      (item.Filters?.category || []).forEach((cat) => allCategories.add(cat));
    });

    const categoryParent = document.querySelector(".category-drop-down");
    categoryParent.innerHTML = "";

    allCategories.forEach((cat) => {
      const label = document.createElement("label");

      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.name = "";

      const span = document.createElement("span");
      span.innerText = cat;

      label.appendChild(checkbox);
      label.appendChild(span);

      categoryParent.appendChild(label);

      checkbox.addEventListener("change", () => {
        if (checkbox.checked) {
          if (!Category_box_text.includes(cat)) Category_box_text.push(cat);
        } else {
          const index = Category_box_text.indexOf(cat);
          if (index > -1) Category_box_text.splice(index, 1);
        }
        console.log(Category_box_text);
        datafetch();
      });
    });
  };

  const datafetch = async () => {
    const year = document.querySelector("#ddlyear")?.value;
    const make = document.querySelector("#ddlmake")?.value;
    const model = document.querySelector("#ddlmodel")?.value;
    const stock_available = document.querySelector(".stock-span-text");
    const Max_price = document.querySelector("#inputPriceMax");
    const filter_price_text = document.querySelector(".price-span-text");
    let result_inner_container = document.querySelector(
      ".search-results-inner-container"
    );
    const card_template = document.querySelector(".result2");

    if (!year || !make || !model || !result_inner_container || !card_template)
      return;

    try {
      const response = await fetch(
        encodeURI(
          `https://bcnet.partsconnect.co/Handler/PCSearchOptions.ashx?pcid=6104678513&method=SearchProductwithFilter&year=${year}&make=${make}&model=${model}`
        )
      );

      const json = await response.json();
      const fetchData = json.Data || [];
      console.log("All Data:", fetchData);

      const filteredAvailable = fetchData.filter(
        (item) => item.Filters?.availability === true
      );

      console.log("Filtered Available:", filteredAvailable);

      if (stock_available)
        stock_available.innerText = `In Stock (${filteredAvailable.length})`;

      const highest_price = Math.max(...fetchData.map((item) => item.price));
      document.querySelector("#priceMax").value = highest_price;
      if (Max_price) Max_price.value = highest_price;
      if (filter_price_text)
        filter_price_text.innerText = `The highest price is $${highest_price}`;

      if (priceMin && priceMax) {
        priceMin.max = highest_price;
        priceMax.max = highest_price;

        // Also set default values if empty
        if (!priceMax.value) priceMax.value = highest_price;
      }

      result_inner_container.innerHTML = "";

      let finalData = stock ? filteredAvailable : fetchData;

      // Inside datafetch, after getting fetchData:
      if (!categoriesBuilt) {
        buildCategoryCheckboxes(fetchData);
        categoriesBuilt = true;
      }

      // Category filter
      if (Category_box_text.length > 0) {
        finalData = finalData.filter((item) => {
          const itemCategories = item.Filters?.category || [];
          return itemCategories.some((cat) => Category_box_text.includes(cat));
        });
        console.log("Filtered by Category:", finalData);

        if (finalData.length === 0) {
          console.log("No category matches found.");
          result_inner_container.innerHTML = `<div class="no-results">No matching category found.</div>`;
          return; // stop further processing
        }
      } else {
        console.log(
          "No category selected. Proceeding without category filter."
        );
      }

      // Brand filter
      if (brandText.length > 0) {
        finalData = finalData.filter((item) => {
          const brand = item.brand?.trim() || item.vendor?.trim() || "";
          return brandText.includes(brand);
        });

        console.log("Filtered by Brand:", finalData);

        if (finalData.length === 0) {
          console.log("No brand matches found.");
          result_inner_container.innerHTML = `<div class="no-results">No matching brand found.</div>`;
          return; // stop rendering further
        }
      } else {
        console.log("No brand selected. Proceeding without brand filter.");
      }

      const minPrice = parseFloat(inputPriceMin.value);
      const maxPrice = parseFloat(inputPriceMax.value);

      if (!isNaN(minPrice) && !isNaN(maxPrice)) {
        finalData = finalData.filter((item) => {
          const price = parseFloat(item.price);
          return price >= minPrice && price <= maxPrice;
        });

        if (finalData.length === 0) {
          result_inner_container.innerHTML = `<div class="no-results">No products found in selected price range.</div>`;
          return;
        }
      }

      finalData.forEach((item) => {
        const cloned_card = card_template.cloneNode(true);
        
        cloned_card.querySelector(".result-image").src = item.images;
        cloned_card.querySelector(".result-name").innerText = item.name;
        cloned_card.querySelector(".result-note").innerText = item.vendor;
        cloned_card.querySelector(".result-price").innerText = "$" + item.price;
        let product_url = item.product_url.replace(/\/{2}$/, "");
        cloned_card.querySelector("a").href = product_url;
        
        cloned_card.querySelector("button.add-cart").setAttribute('data-itemid', item.variant_id);
        cloned_card.querySelector("button.add-cart").setAttribute('data-producturl', product_url);
        cloned_card.querySelector("button.add-cart").setAttribute('onclick', 'addToCartF()');
        cloned_card.classList.add("show-result-card");
        result_inner_container.appendChild(cloned_card);

        
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const datafetch2 = async () => {
    const year = document.querySelector("#ddlyear")?.value;
    const make = document.querySelector("#ddlmake")?.value;
    const model = document.querySelector("#ddlmodel")?.value;
    const stock_available = document.querySelector(".stock-span-text");
    const Max_price = document.querySelector("#inputPriceMax");
    const filter_price_text = document.querySelector(".price-span-text");
    let result_inner_container = document.querySelector(
      ".search-results-inner-container"
    );
    const card_template = document.querySelector(".result2");

    if (!year || !make || !model || !result_inner_container || !card_template)
      return;

    try {
      const response = await fetch(
        encodeURI(
          `https://bcnet.partsconnect.co/Handler/PCSearchOptions.ashx?pcid=6104678513&method=SearchProductwithFilter&year=${year}&make=${make}&model=${model}`
        )
      );

      const json = await response.json();
      const fetchData = json.Data || [];
      console.log("All Data:", fetchData);

      const filteredAvailable = fetchData.filter(
        (item) => item.Filters?.availability === true
      );

      console.log("Filtered Available:", filteredAvailable);

      if (stock_available)
        stock_available.innerText = `In Stock (${filteredAvailable.length})`;

      // const highest_price = Math.max(...fetchData.map((item) => item.price));
      // if (Max_price) Max_price.value = highest_price;
      // if (filter_price_text)
      //   filter_price_text.innerText = `The highest price is $${highest_price}`;

      // if (priceMin && priceMax) {
      //   priceMin.max = highest_price;
      //   priceMax.max = highest_price;

      //   // Also set default values if empty
      //   if (!priceMax.value) priceMax.value = highest_price;
      // }

      result_inner_container.innerHTML = "";

      let finalData = stock ? filteredAvailable : fetchData;

      // Category filter
      if (Category_box_text.length > 0) {
        finalData = finalData.filter((item) => {
          const itemCategories = item.Filters?.category || [];
          return itemCategories.some((cat) => Category_box_text.includes(cat));
        });

        console.log("Filtered by Category:", finalData);

        if (finalData.length === 0) {
          console.log("No category matches found.");
          result_inner_container.innerHTML = `<div class="no-results">No matching category found.</div>`;
          return; // stop further processing
        }
      } else {
        console.log(
          "No category selected. Proceeding without category filter."
        );
      }

      // Brand filter
      if (brandText.length > 0) {
        finalData = finalData.filter((item) => {
          const brand = item.brand?.trim() || item.vendor?.trim() || "";
          return brandText.includes(brand);
        });

        console.log("Filtered by Brand:", finalData);

        if (finalData.length === 0) {
          console.log("No brand matches found.");
          result_inner_container.innerHTML = `<div class="no-results">No matching brand found.</div>`;
          return; // stop rendering further
        }
      } else {
        console.log("No brand selected. Proceeding without brand filter.");
      }

      const minPrice = parseFloat(inputPriceMin.value);
      const maxPrice = parseFloat(inputPriceMax.value);

      if (!isNaN(minPrice) && !isNaN(maxPrice)) {
        finalData = finalData.filter((item) => {
          const price = parseFloat(item.price);
          return price >= minPrice && price <= maxPrice;
        });

        if (finalData.length === 0) {
          result_inner_container.innerHTML = `<div class="no-results">No products found in selected price range.</div>`;
          return;
        }
      }

      finalData.forEach((item) => {
        const cloned_card = card_template.cloneNode(true);
        cloned_card.querySelector(".result-image").src = item.images;
        cloned_card.querySelector(".result-name").innerText = item.name;
        cloned_card.querySelector(".result-note").innerText = item.vendor;
        cloned_card.querySelector(".result-price").innerText = "$" + item.price;
        let product_url = item.product_url.replace(/\/{2}$/, "");
        cloned_card.querySelector("a").href = product_url;
        cloned_card.querySelector("button.add-cart").setAttribute('data-producturl', product_url);
        cloned_card.querySelector("button.add-cart").setAttribute('data-itemid', item.variant_id);
        cloned_card.querySelector("button.add-cart").setAttribute('onclick', 'addToCartF()');
        cloned_card.classList.add("show-result-card");
        result_inner_container.appendChild(cloned_card);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  function updateFilterBarRange() {
    let min = parseFloat(priceMin.value);
    let max = parseFloat(priceMax.value);
    const maxLimit = parseFloat(priceMin.max);

    if (min > max) {
      [priceMin.value, priceMax.value] = [priceMax.value, priceMin.value];
      [min, max] = [max, min];
    }

    let minPercent = (min / maxLimit) * 100;
    let maxPercent = (max / maxLimit) * 100;

    if (Number.isNaN(minPercent)) {
      minPercent = 0;
    }

    if (Number.isNaN(maxPercent)) {
      maxPercent = 100;
    }

    filterBarRange.style.setProperty("--range-max", `${maxPercent}%`);
    filterBarRange.style.setProperty("--range-min", `${minPercent}%`);

    inputPriceMin.value = min.toFixed(2);
    inputPriceMax.value = max.toFixed(2);
    datafetch2(); // Fetch data on every price change
  }

  priceMin.addEventListener("change", updateFilterBarRange);
  priceMax.addEventListener("change", updateFilterBarRange);
  updateFilterBarRange();
  let attempt = 0;
  const checkFilterInterval = setInterval(() => {
    if (
      document.querySelector(".filter-component") &&
      document.querySelector(".search-results-container")
    ) {
      moveAndFetch();
      clearInterval(checkFilterInterval);
    }
    if (++attempt > 20) clearInterval(checkFilterInterval);
  }, 500);
});
